import { render, staticRenderFns } from "./BajasCobranzaVerDetalle.vue?vue&type=template&id=c1c27c6e&"
import script from "./BajasCobranzaVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./BajasCobranzaVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c1c27c6e', component.options)
    } else {
      api.reload('c1c27c6e', component.options)
    }
    module.hot.accept("./BajasCobranzaVerDetalle.vue?vue&type=template&id=c1c27c6e&", function () {
      api.rerender('c1c27c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasCobranza/gridActions/BajasCobranzaVerDetalle.vue"
export default component.exports